export const GET_BRANCHES = "get_branches";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const GET_OVERVIEW = "get_customer_overview";
export const ERROR = "error";
